export const MIGRATE_ASSET = '@hfty-asset-migrate/MIGRATE_ASSET'
export const SUBMIT_MIGRATE_ASSET = '@hfty-asset-migrate/SUBMIT_MIGRATE_ASSET'
